export class TimeoutPromise {

    constructor(timeout:number) {
        return new Promise((resolve, reject) => {
            setTimeout(resolve,timeout);
        });
    }
}

export {};